// src/components/Admin/StudentHomeCmp/StudenthomePortalCmp/SalaActive.jsx

import React, { useEffect, useState, useCallback } from "react";
import { Loader, Message, Icon } from "semantic-ui-react";
import { DidacticRoutesAPI } from "../../../../api";
import "./SalaActive.scss";

const didacticRoutesAPI = new DidacticRoutesAPI();

/**
 * Función auxiliar para mapear categorías a clases CSS (si quieres círculos de colores)
 */
const getCircleClass = (categoryName) => {
  const cat = categoryName.trim().toLowerCase();
  if (cat.includes("humanas")) return "circle--ciencias-humanas";
  if (cat.includes("naturales")) return "circle--ciencias-naturales";
  if (cat.includes("historia")) return "circle--historia";
  if (cat.includes("matematicas")) return "circle--matematicas";
  if (cat.includes("arte")) return "circle--arte";
  if (cat.includes("vida") || cat.includes("saludable")) return "circle--vida-saludable";
  return "circle--gray";
};

export function SalaActive({ routeId, accessToken, onSceneBanner }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [sceneData, setSceneData] = useState(null); // Datos de la escena activa

  // Para refrescar la página (o la lógica que quieras)
  const handleRefresh = () => {
    window.location.reload();
  };

  // Lógica principal para cargar la escena activa
  const loadSala = useCallback(async () => {
    if (!routeId) return;

    try {
      setLoading(true);
      setError(null);

      // 1. Obtener la ruta
      const routeResult = await didacticRoutesAPI.getRouteById(accessToken, routeId);
      const route = routeResult.route;
      if (!route) {
        setError("Ruta no encontrada");
        return;
      }

      // 2. Revisar si existe escena activa
      const { sceneactive, sceneactive_Id } = route;
      if (!sceneactive_Id) {
        setError("No hay escena activa para esta ruta.");
        return;
      }

      // 3. Obtener todas las escenas de la ruta
      const scenesResult = await didacticRoutesAPI.getScenesByRoute(
        accessToken,
        routeId,
        1,
        100
      );
      const allScenes = scenesResult.scenes || [];

      // 4. Buscar la escena que coincida con el _id activo
      const matchingScene = allScenes.find((sc) => sc._id === sceneactive_Id);
      if (!matchingScene) {
        setError("La escena activa no se encontró.");
        return;
      }

      // 5. Guardar datos de la escena para el render
      const data = {
        image: matchingScene.bannertopUrl,
        title: matchingScene.title,
        category: matchingScene.category.join(", "),
        subcategory: matchingScene.subcategory.join(", "),
        sceneactiveUrl: sceneactive,
      };
      setSceneData(data);

      // 6. Notificar al padre la URL del banner, si onSceneBanner está definido
      //console.log("Scene banner =>", matchingScene.bannertopUrl);
      if (onSceneBanner) {
        onSceneBanner(matchingScene.bannertopUrl);
      }
    } catch (err) {
      console.error(err);
      setError(err.message || "Error desconocido");
    } finally {
      setLoading(false);
    }
  }, [accessToken, routeId, onSceneBanner]);

  // Efecto para cargar la sala al montar o cuando cambie routeId
  useEffect(() => {
    if (routeId) {
      loadSala();
    }
  }, [routeId, loadSala]);

  // Render si no hay routeId
  if (!routeId) {
    return (
      <div style={{ textAlign: "center", padding: "2rem" }}>
        <p>No hay escena activa</p>
        <button className="btn-add-route" onClick={handleRefresh}>
          <Icon name="refresh" />
          Actualizar
        </button>
      </div>
    );
  }

  // Render de carga
  if (loading) {
    return <Loader active inline="centered">Cargando sala...</Loader>;
  }

  // Render de error
  if (error) {
    return (
      <Message negative>
        <Message.Header>Error</Message.Header>
        <p>{error}</p>
      </Message>
    );
  }

  // Render final de la escena
  return sceneData ? (
    <div className="e-card-scene sala-active-card">
      {/* Imagen de banner */}
      <img className="card-banner" src={sceneData.image} alt={sceneData.title} />

      <div className="card-body">
        <p className="card-createdby">Creado por: Educa360</p>

        {/* Circulitos de categoría */}
        <div className="card-circles">
          {sceneData.category.split(",").map((cat) => {
            const circleClass = getCircleClass(cat);
            return <div key={cat} className={`circle ${circleClass}`} />;
          })}
          {sceneData.subcategory && (
            <h4 className="card-subcategorie">{sceneData.subcategory}</h4>
          )}
        </div>

        <h3 className="card-title">{sceneData.title}</h3>
        <hr className="card-divider" />

        <div className="card-actions">
          <button
            className="btn-add-route"
            onClick={() =>
              window.open(sceneData.sceneactiveUrl, "_blank", "noopener,noreferrer")
            }
          >
            <Icon name="sign-in" />
            Entrar
          </button>
        </div>
      </div>
    </div>
  ) : (
    <p>No se pudo cargar la información de la escena activa.</p>
  );
}
